"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragPanel = void 0;
var React = require("react");
var _Core_1 = require("../_Core");
var JS = require("../_Core/js");
var settings = require("../_Core/Settings");
var Buttons_1 = require("../Buttons");
var Icon_1 = require("../Icons/Icon/Icon");
var DragPanel_styles_1 = require("./DragPanel.styles");
var DragPanel = /** @class */ (function (_super) {
    __extends(DragPanel, _super);
    function DragPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.settingName = "PanelHidden";
        _this.isVisible = true;
        _this.isBottomPanelVisible = function () {
            return _this.isVisible;
        };
        _this.hideBottomPanel = function () {
            JS.Hide(_this.bottomPanelRef.current);
            JS.Hide(_this.sliderBarRef.current);
            _this.setState({ ShowButton: true });
            _this.isVisible = false;
            settings.saveSetting(_this.settingName, true);
            if (_this.props.OnPanelHide) {
                _this.props.OnPanelHide();
            }
        };
        _this.showBottomPanel = function () {
            JS.Show(_this.bottomPanelRef.current);
            JS.Show(_this.sliderBarRef.current);
            _this.setState({ ShowButton: false });
            _this.isVisible = true;
            settings.saveSetting(_this.settingName, false);
            JS.AddClass(_this.topPanelRef.current, "animation");
            _this.topPanelRef.current.style.height = "";
            _this.bottomPanelRef.current.style.height = "";
            window.setTimeout(function () {
                JS.removeClass(_this.topPanelRef.current, "animation");
            }, 250);
            if (_this.props.OnPanelShow) {
                _this.props.OnPanelShow();
            }
        };
        _this.buildDraggableRow = function () {
            var element = [];
            var total = React.Children.count(_this.props.children);
            // this system only supports 2 panels
            if (total !== 2) {
                element.push(React.createElement(DragPanel_styles_1.Error, { key: 0 }, "Component must have only 2 children, of type 'DragPanelItem'"));
                _this.hasError = true;
            }
            else {
                var childrenArray = React.Children.toArray(_this.props.children);
                element.push(React.createElement(DragPanel_styles_1.PanelWrapper, { key: 0, ref: _this.topPanelRef }, childrenArray[0]));
                element.push(React.createElement(DragPanel_styles_1.DragBar, { key: 1, "aria-hidden": false, ref: _this.sliderBarRef },
                    React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.EllipsesHorizontal, Height: "13px", Width: "13px" })));
                element.push(React.createElement(DragPanel_styles_1.PanelWrapper, { key: 2, ref: _this.bottomPanelRef }, childrenArray[1]));
            }
            return (element);
        };
        _this.state = {
            BottomPanelVisibility: true,
            ShowButton: false,
        };
        _this.containerRef = React.createRef();
        _this.sliderBarRef = React.createRef();
        _this.topPanelRef = React.createRef();
        _this.bottomPanelRef = React.createRef();
        return _this;
    }
    DragPanel.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.hasError) {
            var initialState = settings.loadSetting(this.settingName, false);
            var bottomPanelCollapsePoint_1 = this.props.BottomCollapsePoint || 50;
            var isScrolling_1 = false;
            var clickPoint_1 = 0;
            this.sliderBarRef.current.onmousedown = function (e) {
                isScrolling_1 = true;
                clickPoint_1 = e.offsetY;
            };
            document.onmouseup = function () {
                if (isScrolling_1) {
                    isScrolling_1 = false;
                    var bottomPosition = _this.bottomPanelRef.current.getBoundingClientRect().height;
                    if (bottomPosition <= bottomPanelCollapsePoint_1) {
                        _this.hideBottomPanel();
                    }
                }
            };
            this.containerRef.current.onmousemove = function (e) {
                if (isScrolling_1) {
                    var containerPosition = _this.containerRef.current.getBoundingClientRect();
                    var height = containerPosition.height;
                    var Ypos = (e.clientY - containerPosition.top);
                    // dont allow the top panel to be hidden
                    if (Ypos < 50) {
                        Ypos = 50;
                    }
                    var topPanelHeight = (Ypos - clickPoint_1);
                    var bottomPanelHeight = (height - Ypos - clickPoint_1);
                    _this.topPanelRef.current.style.height = topPanelHeight + "px";
                    _this.bottomPanelRef.current.style.height = bottomPanelHeight + "px";
                }
            };
            if (initialState) {
                this.hideBottomPanel();
            }
        }
    };
    DragPanel.prototype.render = function () {
        return (React.createElement(DragPanel_styles_1.Component, null,
            this.state.ShowButton &&
                React.createElement(DragPanel_styles_1.ShowButtonContainer, null,
                    React.createElement(Buttons_1.SecondaryButton, { OnClick: this.showBottomPanel, Caption: this.props.ButtonCaption, Disabled: false })),
            React.createElement(DragPanel_styles_1.Container, { ref: this.containerRef }, this.buildDraggableRow())));
    };
    return DragPanel;
}(React.PureComponent));
exports.DragPanel = DragPanel;
